// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CertifiedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CertifiedIcon" ref={forwardedRef} {...props}>
      <path d="M8.783 13.29 14 8.073l-.979-.98-4.24 4.24-1.303-1.304L6.5 11.007z" />
      <path d="M9.377 1.992a1 1 0 0 1 1.247 0L11.9 3.01a1 1 0 0 0 .67.217l1.63-.074a1 1 0 0 1 1.009.734l.434 1.573a1 1 0 0 0 .413.57l1.363.898a1 1 0 0 1 .385 1.186L17.23 9.643a1 1 0 0 0 0 .703l.574 1.528a1 1 0 0 1-.385 1.186l-1.363.9a1 1 0 0 0-.413.568l-.434 1.574a1 1 0 0 1-1.01.733l-1.63-.074A1 1 0 0 0 11.9 16.98l-1.276 1.018a1 1 0 0 1-1.247 0L8.101 16.98a1 1 0 0 0-.669-.218l-1.63.074a1 1 0 0 1-1.01-.733L4.36 14.528a1 1 0 0 0-.414-.569L2.583 13.06a1 1 0 0 1-.386-1.186l.574-1.528a1 1 0 0 0 0-.703L2.197 8.114a1 1 0 0 1 .386-1.186L3.945 6.03A1 1 0 0 0 4.36 5.46l.433-1.573a1 1 0 0 1 1.01-.734l1.63.074A1 1 0 0 0 8.101 3.01zm-.34 2.19a2.5 2.5 0 0 1-1.672.544L6.132 4.67 5.805 5.859A2.5 2.5 0 0 1 4.77 7.281l-1.03.68.434 1.154a2.5 2.5 0 0 1 0 1.758l-.433 1.155 1.03.68a2.5 2.5 0 0 1 1.033 1.421l.327 1.19 1.233-.056a2.5 2.5 0 0 1 1.672.543L10 16.576l.964-.77a2.5 2.5 0 0 1 1.672-.543l1.232.055.328-1.189a2.5 2.5 0 0 1 1.033-1.422l1.03-.68-.434-1.154a2.5 2.5 0 0 1 0-1.758L16.26 7.96l-1.03-.679a2.5 2.5 0 0 1-1.033-1.422L13.869 4.67l-1.232.056a2.5 2.5 0 0 1-1.672-.544L10 3.413z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CertifiedIcon = /* @__PURE__ */ Object.assign(
  CertifiedIconComponent,
  { displayName: 'CertifiedIcon' },
);
